"use client";

import {
  getAllClientAgeRangeSlugs,
  getClientAgeRangeBySlug,
} from "~/lib/client-age-ranges";
import { PRICE_RANGES } from "~/lib/price-ranges";
import type { TherapyDirectoryFilters } from "~/lib/therapy-directory-filters";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface DirectoryFilterSelectsProps {
  filters: TherapyDirectoryFilters;
  isPending: boolean;
  onUpdate: (updates: Record<string, string | undefined>) => void;
}

const ALL_ADULTS = "adults";
const ALL_PRICES = "all-prices";
const ALL_GENDERS = "all-genders";

export default function DirectoryFilterSelects({
  filters,
  isPending,
  onUpdate,
}: DirectoryFilterSelectsProps) {
  return (
    <div className="flex items-center gap-2">
      <Select
        value={filters.ageRange ?? ALL_ADULTS}
        disabled={isPending}
        onValueChange={(value) =>
          onUpdate({ age: value === ALL_ADULTS ? undefined : value })
        }
      >
        <SelectTrigger aria-label="Uzrast klijenta" className="w-[92px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_ADULTS}>Uzrast</SelectItem>
          {getAllClientAgeRangeSlugs().map((slug) => (
            <SelectItem key={slug} value={slug}>
              {getClientAgeRangeBySlug(slug)?.label.replace(
                "Terapeuti za ",
                "",
              )}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.priceRange ?? ALL_PRICES}
        disabled={isPending}
        onValueChange={(value) =>
          onUpdate({ price: value === ALL_PRICES ? undefined : value })
        }
      >
        <SelectTrigger aria-label="Cena sesije" className="w-[122px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_PRICES}>Cena sesije</SelectItem>
          {Object.entries(PRICE_RANGES).map(([slug, range]) => (
            <SelectItem key={slug} value={slug}>
              {range.label.replace("Terapeuti ", "")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.gender ?? ALL_GENDERS}
        disabled={isPending}
        onValueChange={(value) =>
          onUpdate({
            gender: value === "FEMALE" || value === "MALE" ? value : undefined,
          })
        }
      >
        <SelectTrigger aria-label="Pol terapeuta" className="w-[132px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_GENDERS}>Pol terapeuta</SelectItem>
          <SelectItem value="FEMALE">Žena</SelectItem>
          <SelectItem value="MALE">Muškarac</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
